import { useAppLifeCycle } from 'shared/src/hooks';
import { bridge, useAsyncEffect } from 'shared/src/utils';
import type { Dispatch, SetStateAction } from 'react';

export const useSyncLocalGoodsLike = (
  setLikeMap: Dispatch<SetStateAction<{ [key: number]: boolean }>>,
) => {
  const { lifeCycle } = useAppLifeCycle();

  useAsyncEffect(async () => {
    if (lifeCycle === 'viewWillAppear') {
      const localGoodsLike = await bridge.getLocalGoodsLike();

      setLikeMap(prev => ({
        ...prev,
        ...localGoodsLike,
      }));
    }
  }, [lifeCycle]);
};
